module.exports = __webpack_public_path__ + "img/ST_logo_onblack.fcc1b500.png";